// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"b94ae75a0c498bd1cb44","966":"7ec7db74324868608218"}[chunkId] + ".js";
};